import { Box, type SxProps } from '@mui/material';
import { type LiHTMLAttributes, forwardRef } from 'react';

import { MarkdownCopyToClipboard } from './CopyToClipboardButton.js';
import type { ExtraProps } from './types.js';

const LIST_SX: SxProps = {
  /**
   * Override Bootstrap's default list styles
   */
  paddingLeft: 3,
  marginBottom: 0,
  '&> * + *': {
    marginTop: 0.5,
  },
};

export const MarkdownUl = forwardRef<HTMLUListElement, ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return <Box ref={ref} component="ul" sx={LIST_SX} {...rest} />;
});
MarkdownUl.displayName = 'MarkdownUl';

export const MarkdownOl = forwardRef<HTMLOListElement, ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return <Box ref={ref} component="ol" sx={LIST_SX} {...rest} />;
});
MarkdownOl.displayName = 'MarkdownOl';

export const MarkdownListItem = forwardRef<
  HTMLLIElement,
  LiHTMLAttributes<HTMLLIElement> & ExtraProps
>((props, ref) => {
  const { node, children, ...rest } = props;
  return (
    <Box
      ref={ref}
      component="li"
      sx={{
        fontSize: (theme) => theme.typography.body2.fontSize,
        lineHeight: (theme) => theme.typography.body2.lineHeight,
        '&> ul, li': {
          marginTop: 0.5,
        },
      }}
      {...rest}
    >
      {children}
      <MarkdownCopyToClipboard content={children} />
    </Box>
  );
});
MarkdownListItem.displayName = 'MarkdownListItem';
